import React from "react";

const testimonials = [
  {
    name: "Head of Operations, Global Manufacturing Firm",
    text: "Team Technoserve didn’t rush for the solutions. It understood our challenges, asked the right questions, and delivered outcomes that actually solved our problems",
  },
  {
    name: "CEO & President, Fintech Company",
    text: "They worked like an extension of our own team. The communication was transparent, the approach was practical, and the results spoke for themselves.",
  },
  {
    name: "CTO, Fashion Brand",
    text: "In an industry where overpromising is common, Technoserve stood out for its honesty and consistency. They only commit to what they can deliver and then exceed it.",
  },
];

const Testimonials = () => (
  <section className="testimonials-section premium-testimonials-section mt-5">
    <div className="title_line text-center p-1">What Our Clients Say</div>
    <p className="testimonials-subtitle">
      Trusted by enterprises and innovators worldwide for digital transformation
      and measurable results.
    </p>
    <div className="testimonials-grid premium-testimonials-grid">
      {testimonials.map((t, i) => (
        <div className="testimonial-card premium-testimonial-card" key={i}>
          <div className="testimonial-avatar" role="img" aria-label="Client">
            <span class="material-icons material-symbols-outlined chat_icon">
              chat
            </span>
          </div>
          <p className="testimonial-text">“{t.text}”</p>
          <span className="testimonial-name">{t.name}</span>
        </div>
      ))}
    </div>
  </section>
);

export default Testimonials;
